import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../../../core/services/data.service';


@Component({
  selector: 'app-camerainfoui',
  standalone: true,
  imports: [],
  templateUrl: './camerainfoui.component.html',
  styleUrl: './camerainfoui.component.css'
})
export class CamerainfouiComponent implements OnInit {
  @Input() cameraId!: string;
  @Input() sensorId!: string;

  camera: any;
  cameraSessions: any[] = [];
  cameraSessionHistory: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.loadInfo();
  }

  loadInfo() {
    Promise.all([
      this.dataService.getSensorList().toPromise(),
      this.dataService.getCameraSessions(this.cameraId).toPromise(),
      this.dataService.getCameraSessionHistory(this.cameraId).toPromise()
        
    ]).then(([sensorList, sessionResult, sessionHistoryResult]) => {
      const cameraInfo = (sensorList.cameraList || []).find((c: any) => c.id == this.sensorId);
      this.camera = cameraInfo;

      this.cameraSessions = (sessionResult.rows || []).map((session: any) => ({
        ...session,
        beingViewed: 'No'
      }));

      this.cameraSessionHistory = sessionHistoryResult.rows || [];
    });
  }

  stopCameraSession(session: any) {
    this.loadInfo();
  }
}